<template>
  <pdf ref="pdf" src="https://company.oriomics.com/uploads/20210127/c590ec8498ce945b1483b3b372db8a40.docx"> </pdf>
</template>

<script>
import pdf from "vue-pdf";
export default {
  name: "lookpdf",
  components: {
    pdf,
  },
  created() {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/pdf.vue